<div class="text-center" [ngClass]="{ 'small-loader': small }">
  <div class="wrapper">
    <div class="pagination-wrapper mb-4" [attr.aria-hidden]="true">
      {{
        'common.pagination_hint'
          | cxTranslate
            : {
                itemCount: itemCount,
                totalItemCount: totalItemCount || 0,
                itemTypeName: totalItemCountName || ('common.defaultItemTypeName_hint' | cxTranslate),
              }
      }}
    </div>
    <div class="progressbar-wrapper mb-4">
      <div class="progress-bar">
        <div
          class="progress"
          [style]="'width:' + percentage + '%'"
          role="progressbar"
          [attr.aria-label]="
            'common.pagination_heading'
              | cxTranslate: { itemTypeName: totalItemCountName || ('common.defaultItemTypeName_hint' | cxTranslate) }
          "
          [attr.aria-valuemax]="totalItemCount"
          [attr.aria-valuenow]="itemCount"
        ></div>
      </div>
    </div>
  </div>
  <py-action-button
    *ngIf="showLoadMoreButton"
    [buttonClass]="small ? 'btn btn-secondary btn-sm' : 'btn btn-secondary'"
    (activate)="handleClick()"
    [disabled]="disabled || totalPageCount <= currentPageNumber + 1"
    [loading]="loading"
    [buttonLabel]="'common.loadMore_action' | cxTranslate"
    [buttonId]="buttonId"
  >
  </py-action-button>
</div>
